import { schAlertType } from '@aloft/toolkit-shared';

import { AlertDefinition } from '../../types.ts';
import { calcSiteToValueRatios } from '../utils/calcSiteToValueRatios.ts';
import { getDepreciatedCostPageRoute } from '../utils/getDepreciatedCostPageRoute.ts';

const formatRatio = (ratio: number) => (ratio * 100).toFixed(1);

export const bracketedSiteToValueRatio: AlertDefinition = (params) => {
  const siteToValueRatios = calcSiteToValueRatios(params);
  if (!siteToValueRatios) return undefined;

  const { minCompRatio, maxCompRatio, subjectRatio } = siteToValueRatios;
  if (subjectRatio <= maxCompRatio && subjectRatio >= minCompRatio) return undefined;

  return {
    type: schAlertType.enum.bracketedSiteToValueRatio,
    status: 'active',
    severity: 'error',
    message: `The Subject's Site to Value Ratio (${formatRatio(subjectRatio)}%) is not bracketed (${formatRatio(minCompRatio)}% - ${formatRatio(maxCompRatio)}%).`,
    propertyID: 'subject',
    fixingInfo: {
      tips: "Tips: Similar Site to Value Ratios indicate the properties compete in the same market, and that site adjustments will have proportionally similar impacts. If the Subject's Site to Value Ratio isn't bracketed, it may indicate that the Subject's Improvements or Site are considerably above or below average for the market area.",
      pairedCostRouteItem: getDepreciatedCostPageRoute(params.order),
      fixingMethod: ['comment', 'action'],
      commentAlwaysRequired: false,
    },
    triggers: [],
  };
};
